/* Konfigurator Logik  */


/* ============================
   Polyfill + Mini-Helpers
   ============================ */
if (!window.CSS || !CSS.escape) {
  window.CSS = window.CSS || {};
  CSS.escape = CSS.escape || (s => String(s).replace(/([ #;?%&,.+*~\':"!^$[\]()=>|/@])/g,'\\$1'));
}
const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

/* ============================
   Selektoren
   ============================ */
const SEL = {
  speedWrap: '.gpo-speed',
  battWrap : '.gpo-battery',
  motorWrap: '.gpo-motor',

  speedName: '[name="Geschwindigkeit"]',
  battName : '[name="Akku"]',
  motorName: '[name="Motor"]',
  gradeName: '[name="Ausstattung"]',
  tiresName: '[name="Reifen"]',
  tiresGroup: '.gpo-tires',
  lightsName:'[name="Licht"]',
  travelName:'[name="Travel"]',
  cockpitName:'[name="Ergonomic & Cockpit"]',

  /* NEU: Gruppen wie .gpo-package */
  wheelsGroup : '.gpo-wheels',
  cockpitGroup: '.gpo-cockpit',
  lastcallGroup: '.gpo-lastcall',

  displayGroup: '.gpo-display',
  displayName : '[name="Displays"]'
};

/* ============================
   Utils (by name / global)
   ============================ */
const getCheckedVal = nameSel => $(`${nameSel}:checked`)?.value?.trim() || '';
const battCode  = v => (String(v||'').match(/\d+/)||[])[0] || '';
const gradeCode = v => (String(v||'').match(/\b([369]\.0)\b/)||[])[1] || '';
const isSPedBattLabel = v => /\(S-Pedelec\)/i.test(String(v||''));

function getSelectedFrameSize(){
  return document.querySelector('input[name="Rahmengröße"]:checked')?.value || '';
}

function hardDisable(inp, title){
  if (!inp) return;
  inp.disabled = true;

  const card = inp.closest('.gpo-ov-item') || inp.closest('label');
  if (card){
    card.classList.add('is-disabled');
    card.style.pointerEvents = 'none';
    if (title) card.title = title;
  }
}



function softEnableAllByName(nameSel){
  $$(nameSel).forEach(inp=>{
    inp.disabled = false;
    const lab = inp.closest('label, .gpo-ov-item');
    if (lab){ lab.classList.remove('is-disabled'); lab.style.pointerEvents=''; lab.removeAttribute('title'); }
  });
}


// <<< NEU: direkt über visuallyDisableByInput einfügen
function uncheckAndClean(inp){
  if (!inp) return;
  if (inp.checked || inp.getAttribute('previous-value') === 'checked'){
    inp.checked = false;
    inp.removeAttribute('checked');
    inp.setAttribute('previous-value', 'false'); // <<< WICHTIG
    const lab = inp.closest('label, .gpo-ov-item');
    if (lab){
      lab.classList.remove('is-checked');
      lab.removeAttribute('aria-checked');
    }
    // Globo updaten
    inp.dispatchEvent(new Event('input',  { bubbles:true }));
    inp.dispatchEvent(new Event('change', { bubbles:true }));
  }
}



function visuallyDisableByInput(inp, title){
  if (!inp) return;

  // Tooltip fix für 9.0 und 3.0
  if (inp.matches(SEL.gradeName) && (/9\.0/.test(inp.value || '') || /3\.0/.test(inp.value || ''))) {
    title = 'Ausverkauft';
  }

  uncheckAndClean(inp);
  inp.disabled = true;

  const lab  = inp.closest('label, .gpo-ov-item');
  const card = inp.closest('.gpo-ov-item');

  [lab, card, inp].forEach(el=>{
    if (!el) return;
    el.classList.add('is-disabled');
    el.style.pointerEvents = 'none';
    el.title = title || '';
  });
}






function softDisableValuesByName(nameSel, values, title){
  values.forEach(v=>{
    const inp = document.querySelector(`${nameSel}[value="${CSS.escape(v)}"]`);
    if (inp) visuallyDisableByInput(inp, title);
  });
}
function pickByName(nameSel, value){
  const inp = $(`${nameSel}[value="${CSS.escape(value)}"]`);
  if (inp && !inp.checked && !inp.disabled) inp.click();
}
function pickFirstPresent(nameSel, candidates){
  for (const v of candidates){
    const el = document.querySelector(`${nameSel}[value="${CSS.escape(v)}"]`);
    if (el && !el.disabled){ pickByName(nameSel, v); return true; }
  }
  return false;
}





/* ============================
   Gruppen-Utils (für .gpo-*)
   ============================ */
function groupRoot(sel){ return document.querySelector(sel) || null; }
function groupInputs(sel){
  const root = groupRoot(sel);
  return root ? Array.from(root.querySelectorAll('input[type="radio"], input[type="checkbox"]')) : [];
}
function groupEnableAll(sel){
  groupInputs(sel).forEach(inp=>{
    inp.disabled = false;
    const lab = inp.closest('label, .gpo-ov-item');
    if (lab){ lab.classList.remove('is-disabled'); lab.style.pointerEvents=''; lab.removeAttribute('title'); }
  });
}
function groupInputByValue(sel, value){
  const root = groupRoot(sel);
  return root ? root.querySelector(`input[value="${CSS.escape(value)}"]`) : null;
}
function groupPickByValue(sel, value){
  const inp = groupInputByValue(sel, value);
  if (inp && !inp.checked && !inp.disabled) inp.click();
}
function groupPickFirstPresent(sel, candidates){
  for (const v of candidates){
    const el = groupInputByValue(sel, v);
    if (el && !el.disabled){ groupPickByValue(sel, v); return true; }
  }
  return false;
}
function groupSoftDisableValue(sel, value, title){
  const inp = groupInputByValue(sel, value);
  if (inp) visuallyDisableByInput(inp, title);
}

/* ===== Globale Fallback-Utils (falls Gruppe mal fehlt / Duplikate im DOM) ===== */
function findInputsByValue(value){
  return Array.from(document.querySelectorAll(`input[value="${CSS.escape(value)}"]`));
}
function hideByValue(value, hide){
  findInputsByValue(value).forEach(inp=>{
    const card = inp.closest('.gpo-ov-item') || inp.closest('label') || inp.parentElement;
    if (card) card.style.display = hide ? 'none' : '';
  });
}
function setOptionGlobally(value, allowed, titleWhenDisabled){
  const inputs = findInputsByValue(value);
  if (!inputs.length) return false;
  inputs.forEach(inp => allowed ? enableInput(inp) : disableInput(inp, titleWhenDisabled));
  return true;
}
function enableInput(inp){
  inp.disabled = false;
  const lab = inp.closest('label, .gpo-ov-item');
  if (lab){ lab.classList.remove('is-disabled'); lab.style.pointerEvents=''; lab.removeAttribute('title'); }
}


function disableInput(inp, title){


   if (!inp) return;

  // 🔥 9.0 und 3.0 immer überschreiben
  if (inp.matches(SEL.gradeName) && (/9\.0/.test(inp.value || '') || /3\.0/.test(inp.value || ''))) {
    title = 'Ausverkauft';
  }

  uncheckAndClean(inp);                 // <<< hinzugefügt
  inp.disabled = true;
  const lab  = inp.closest('label, .gpo-ov-item');
  if (lab){
    lab.classList.add('is-disabled');
    lab.style.pointerEvents='none';
    if (title) lab.title = title;
  }
} 



// unter "Gruppen-Utils" hinzufügen:
function groupSoftDisableUpgrades(sel, title){
  const root = groupRoot(sel);
  if (!root) return;
  const inputs = root.querySelectorAll('input[type="radio"], input[type="checkbox"]');
  inputs.forEach(inp=>{
    const card = inp.closest('.gpo-ov-item');
    // Upgrade-Heuristik: hat eine Preis-Span .addOn
    const isUpgrade = !!card?.querySelector('.addOn');
    if (isUpgrade) visuallyDisableByInput(inp, title);
  });
}

// Wählt die erste aktivierbare Option in der Gruppe
function groupPickFirstEnabled(sel){
  const root = groupRoot(sel);
  if (!root) return false;
  const inputs = root.querySelectorAll('input[type="radio"], input[type="checkbox"]');
  for (const inp of inputs){
    if (!inp.disabled){
      if (!inp.checked) inp.click();
      return true;
    }
  }
  return false;
}





/* ============================
   Sichtbarkeit ausgewählter Optionen
   ============================ */
function syncCheckedStyles(nameSel){
  const inputs = Array.from(document.querySelectorAll(nameSel));
  inputs.forEach(inp=>{
    const lab = inp.closest('label, .gpo-ov-item');
    if (!lab) return;
    if (inp.checked && !inp.disabled){
      lab.classList.add('is-checked');
      lab.setAttribute('aria-checked','true');
    } else {
      lab.classList.remove('is-checked');
      lab.removeAttribute('aria-checked');
    }
  });
}

/* ============================
   Drive-/Motor-/Akku-Regeln
   ============================ */
const VALID = {
  'Pedelec': {
    '400': ['Bosch SX.P'],
    '600': ['Bosch PX.P', 'Bosch CX.P','Bosch CX.R'],
    '800': ['Bosch PX.P', 'Bosch CX.P','Bosch CX.R']
  },
  'S-Pedelec': { '800': ['Bosch CX.S'] }
};
const ALL_MOTORS = ['Bosch SX.P','Bosch PX.P','Bosch CX.P','Bosch CX.R','Bosch CX.S'];

const COCKPIT_SPED     = 'Comfort Alu Cockpit (S-Ped)';
const COCKPIT_COMFORT  = 'Comfort Alu Cockpit';
const COCKPIT_SPED_CARBON = 'Enduro Carbon Cockpit (S-Ped)';
const COCKPIT_ENDURO_CARBON = 'Enduro Carbon Cockpit';
const COCKPIT_FALLBACKS = [
  'Sport Alu Cockpit - Serienausstattung',
  'Enduro Alu Cockpit',
  'Enduro Carbon Cockpit',
  COCKPIT_COMFORT
];

const DISPLAY_PURION = 'Purion 200 – Standard Ausstattung';
const DISPLAY_KIOX   = 'KIOX 400C + Mini Remote';

const FAMILY = 'AM';
const HARD_BANS = [
  { grade:'9.0', batt:['600','800'], motor:'Bosch PX.P' },
  { grade:'6.0', batt:['600','800'], motor:'Bosch PX.P' },
  { grade:'3.0', batt:['400','600','800'], motor:'' },
];

const S_TRAVEL_DISABLED = [
  'Fidlock Mounts',
  'Fidlock Mounts L-XL',
  'SPORT Gepäckträger Paket',
  'GT Gepäckträger Paket',
  'Kickstand Hebie'
];
const S_TRAVEL_ALLOWED_PREFERRED = [
  'ABUS ONE KEY Bordo'
];

/* ============================
   NEU: Gruppen-Regelwerk
   ============================ */
const GROUP_RULES = {
  [SEL.wheelsGroup]: {
    options: {
      'ULTRA LIGHT Carbon LRS 9.0': ['9.0'],
      'ULTRA LIGHT Carbon LRS 6.0': ['6.0'],
      'LIGHT Carbon LRS'          : ['6.0','3.0']
    }
  },
  [SEL.cockpitGroup]: {
    options: {
      'Enduro Carbon Cockpit': ['6.0','3.0'],
      'Enduro Alu Cockpit'   : ['6.0','3.0']
    }
  }
};

/* ============================
   Gruppen-Abhängigkeiten anwenden
   ============================ */
function applyGroupDeps(ctx){

  // AM 9.0 und 3.0 markieren für CSS
document.querySelectorAll(`${SEL.gradeName}[value*="9.0"]`).forEach(inp => {
  const card = inp.closest('.gpo-ov-item');
  if (card) card.dataset.grade = "9.0";
});
document.querySelectorAll(`${SEL.gradeName}[value*="3.0"]`).forEach(inp => {
  const card = inp.closest('.gpo-ov-item');
  if (card) card.dataset.grade = "3.0";
});

  if (ctx.family !== 'AM' || !ctx.grade) return;

  Object.entries(GROUP_RULES).forEach(([groupSel, cfg])=>{
    const root = groupRoot(groupSel);
    if (root){
      groupEnableAll(groupSel);

      const allowedMap = cfg.options || {};
      const allowedNow = [];

      Object.entries(allowedMap).forEach(([label, allowedGrades])=>{
        const isAllowed = allowedGrades.includes(ctx.grade);
        const title = 'Nur verfügbar mit ' + allowedGrades.map(g => `AM ${g}`).join(' oder ');
        if (!isAllowed){
          groupSoftDisableValue(groupSel, label, title);
        } else {
          allowedNow.push(label);
        }
      });

      const checked = root.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checked && checked.disabled){
        if (!groupPickFirstPresent(groupSel, allowedNow)) {
          uncheckAndClean(checked);
          const lab = checked.closest('label, .gpo-ov-item');
          if (lab) lab.classList.add('is-disabled');
        }
      }
    }

    // Globales Fallback, falls Gruppe dupliziert/fehlt:
    const allowedMap = (cfg && cfg.options) ? cfg.options : {};
    Object.entries(allowedMap).forEach(([label, allowedGrades])=>{
      const isAllowed = allowedGrades.includes(ctx.grade);
      const title = 'Nur verfügbar mit ' + allowedGrades.map(g => `AM ${g}`).join(' oder ');
      setOptionGlobally(label, isAllowed, title);
    });
  });
}





// In einer Gruppe Optionen per Text/Value (robust) deaktivieren
function groupSoftDisableByText(sel, patterns, title){
  const root = groupRoot(sel);
  if (!root) return;
  const inputs = root.querySelectorAll('input[type="radio"], input[type="checkbox"]');
  inputs.forEach(inp=>{
    const card   = inp.closest('.gpo-ov-item');
    const v      = (inp.value || '').trim();
    const text   = (card?.textContent || '') + ' ' + v;
    const hit    = patterns.some(p => p instanceof RegExp ? p.test(text) : text.toLowerCase().includes(String(p).toLowerCase()));
    if (hit) visuallyDisableByInput(inp, title);
  });
}

function isHiddenOrDisabled(inp){
  if (!inp) return false;
  if (inp.disabled) return true;
  const card = inp.closest('.gpo-ov-item') || inp.closest('label');
  if (!card) return false;
  const cs = window.getComputedStyle(card);
  return cs.display === 'none' || cs.visibility === 'hidden' || card.offsetParent === null;
}

function ensureVisibleSelection(nameSel){
  const checked = document.querySelector(`${nameSel}:checked`);
  if (!checked) return;

  // Wenn die aktuell gewählte Option unsichtbar/disabled ist → abwählen & Fallback wählen
  if (isHiddenOrDisabled(checked)){
    uncheckAndClean(checked);
    // Fallback: erste sichtbare & aktivierbare Option wählen (gleiche Gruppe)
    const candidates = Array.from(document.querySelectorAll(nameSel))
      .filter(inp => !isHiddenOrDisabled(inp) && !inp.disabled);
    if (candidates[0] && !candidates[0].checked){
      candidates[0].click();
    }
  }
}



/* Neue Logik */


/* ============================
   Kern-Logik
   ============================ */
function applyDrive(){
  const uiSpeed = getCheckedVal(SEL.speedName) || 'Pedelec';
  const uiBattV = getCheckedVal(SEL.battName)  || '400 Wh + 400 Wh + 400 Wh + 400 Wh';
  const uiMotor = getCheckedVal(SEL.motorName) || 'Bosch SX.P';
  const uiGrade = getCheckedVal(SEL.gradeName) || '';

  let ctx = {
    speed: uiSpeed,
    batt:  battCode(uiBattV),
    motor: uiMotor,
    grade: gradeCode(uiGrade),
    family: FAMILY
  };

  /* Reset globaler Name-Gruppen */
  softEnableAllByName(SEL.battName);
  softEnableAllByName(SEL.motorName);
  softEnableAllByName(SEL.tiresName);
  softEnableAllByName(SEL.lightsName);
  softEnableAllByName(SEL.travelName);
  softEnableAllByName(SEL.cockpitName);
  groupEnableAll(SEL.lastcallGroup);   // <<< neu, damit Lastcall auch reset bekommt
  softEnableAllByName(SEL.displayName);
  groupEnableAll(SEL.displayGroup);

  if (ctx.speed === 'S-Pedelec') {
    // Akku/Motor
    // Akku/Motor (S-Pedelec)
    // 800er-Visibilität bei S-Pedelec
    hideByValue('800 Wh', true);                 // Pedelec-800 ausblenden
    hideByValue('800 Wh (S-Pedelec)', false);    // S-Ped-800 einblenden

    softDisableValuesByName(SEL.battName, ['400 Wh + 400 Wh','600 Wh','800 Wh'], 'Nur 800 Wh (S-Pedelec) erlaubt');
    pickByName(SEL.battName, '800 Wh (S-Pedelec)');

    softDisableValuesByName(SEL.motorName, ['Bosch SX.P','Bosch PX.P','Bosch CX.P','Bosch CX.R'], 'Nur CX.S erlaubt');
    pickByName(SEL.motorName, 'Bosch CX.S');


    groupSoftDisableValue(SEL.displayGroup, DISPLAY_KIOX, 'Nicht verfügbar bei S-Pedelec');
    setOptionGlobally(DISPLAY_KIOX, false, 'Nicht verfügbar bei S-Pedelec');

    const curDisp = getCheckedVal(SEL.displayName);
    if (curDisp === DISPLAY_KIOX || !curDisp) {
      // Purion wählen, sonst erste erlaubte Option
      if (!pickFirstPresent(SEL.displayName, [DISPLAY_PURION])) {
        groupPickFirstEnabled(SEL.displayGroup);
      }
    }
    // === Cockpit Logik (S-Pedelec) ===
// === Cockpit Logik (S-Pedelec) ===
const cockSel = getCheckedVal(SEL.cockpitName);

// Normales Comfort in S-Ped stets verstecken
hideByValue(COCKPIT_COMFORT, true);

// S-Ped-Cockpits grundsätzlich anzeigen (sichtbar machen)
hideByValue(COCKPIT_SPED,        false);
hideByValue(COCKPIT_SPED_CARBON, false);

// Normale (nicht S-Ped) Cockpits: nur das Enduro CARBON bei S-Ped ausblenden
hideByValue(COCKPIT_ENDURO_CARBON, true);   // <<< nur Carbon verstecken
// Enduro ALU bleibt bewusst sichtbar (kein hide)
 // hideByValue(COCKPIT_ENDURO_ALU, false); // optional, falls du es sicher explizit zeigen willst

// Falls normales Enduro CARBON aktiv war → auf passende S-Ped-Option umstellen
if (cockSel === COCKPIT_ENDURO_CARBON) {
  const prefer = (ctx.grade === '9.0')
    ? [COCKPIT_SPED_CARBON]          // AM 9.0 → S-Ped Carbon erlaubt
    : (ctx.grade === '3.0' || ctx.grade === '6.0')
      ? [COCKPIT_SPED]               // AM 3.0/6.0 → nur S-Ped Alu
      : [COCKPIT_SPED, COCKPIT_SPED_CARBON]; // sonst: irgendein S-Ped

  if (!groupPickFirstPresent(SEL.cockpitGroup, [...prefer, ...COCKPIT_FALLBACKS])) {
    groupPickFirstEnabled(SEL.cockpitGroup);
  }
}


// AM 9.0: Alu S-Ped deaktivieren + verstecken; Carbon S-Ped erlauben
if (ctx.grade === '9.0') {
  // ALU S-Ped global sperren
  setOptionGlobally(COCKPIT_SPED, false, 'Nicht verfügbar mit AM 9.0');
  groupSoftDisableValue(SEL.cockpitGroup, COCKPIT_SPED, 'Nicht verfügbar mit AM 9.0');
  findInputsByValue(COCKPIT_SPED).forEach(inp=>{
    const card = inp.closest('.gpo-ov-item') || inp.closest('label');
    if (card) card.style.display = 'none';
    uncheckAndClean(inp);
  });

  // Carbon S-Ped sicher erlauben/anzeigen
  setOptionGlobally(COCKPIT_SPED_CARBON, true);

  // Falls ALU S-Ped aktiv war → Carbon S-Ped (oder Fallback)
  if (cockSel === COCKPIT_SPED) {
    if (!groupPickFirstPresent(SEL.cockpitGroup, [COCKPIT_SPED_CARBON, ...COCKPIT_FALLBACKS])) {
      groupPickFirstEnabled(SEL.cockpitGroup);
    }
  }

// AM 3.0 oder 6.0: Carbon S-Ped sperren + verstecken; ALU S-Ped erlauben
} else if (ctx.grade === '3.0' || ctx.grade === '6.0') {
  // Carbon S-Ped global sperren
  setOptionGlobally(COCKPIT_SPED_CARBON, false, 'Nicht verfügbar mit AM 3.0 oder 6.0');
  groupSoftDisableValue(SEL.cockpitGroup, COCKPIT_SPED_CARBON, 'Nicht verfügbar mit AM 3.0 oder 6.0');
  findInputsByValue(COCKPIT_SPED_CARBON).forEach(inp=>{
    const card = inp.closest('.gpo-ov-item') || inp.closest('label');
    if (card) card.style.display = 'none';
    uncheckAndClean(inp);
  });

  // ALU S-Ped erlauben (sichtbar lassen)
  setOptionGlobally(COCKPIT_SPED, true);

  // Falls Carbon S-Ped aktiv war → ALU S-Ped (oder Fallback)
  if (cockSel === COCKPIT_SPED_CARBON) {
    if (!groupPickFirstPresent(SEL.cockpitGroup, [COCKPIT_SPED, ...COCKPIT_FALLBACKS])) {
      groupPickFirstEnabled(SEL.cockpitGroup);
    }
  }

// (theoretisch) weitere Grades → beide S-Ped-Cockpits erlauben
} else {
  setOptionGlobally(COCKPIT_SPED, true);
  setOptionGlobally(COCKPIT_SPED_CARBON, true);

  setOptionGlobally(DISPLAY_KIOX, true);
  setOptionGlobally(DISPLAY_PURION, true);

  // Wenn aus irgendeinem Grund ein verstecktes/disabled S-Ped ausgewählt ist → Fallback
  const spedCarbonInp = $(`${SEL.cockpitName}[value="${CSS.escape(COCKPIT_SPED_CARBON)}"]`);
  const spedAluInp    = $(`${SEL.cockpitName}[value="${CSS.escape(COCKPIT_SPED)}"]`);
  const isHidden = (label) => findInputsByValue(label).some(i=>{
    const c = i.closest('.gpo-ov-item') || i.closest('label'); return c && c.style.display === 'none';
  });

  if ((cockSel === COCKPIT_SPED_CARBON && (spedCarbonInp?.disabled || isHidden(COCKPIT_SPED_CARBON))) ||
      (cockSel === COCKPIT_SPED && (spedAluInp?.disabled || isHidden(COCKPIT_SPED)))) {
    if (!groupPickFirstPresent(SEL.cockpitGroup, [COCKPIT_SPED, COCKPIT_SPED_CARBON, ...COCKPIT_FALLBACKS])) {
      groupPickFirstEnabled(SEL.cockpitGroup);
    }
  }
}

// Styles aktualisieren
ensureVisibleSelection(SEL.cockpitName);
syncCheckedStyles(SEL.cockpitName);




    // Licht
    softDisableValuesByName(
      SEL.lightsName,
      ['Ohne Licht'],
      'Nicht verfügbar bei S-Pedelec'
    );
    pickByName(SEL.lightsName, 'S-Ped LIGHT by NIGHT');

    // Reifen sperren
    softDisableValuesByName(SEL.tiresName,  ['Schwalbe Nobby Nic','Eddy Current REAR'], 'Nicht verfügbar bei S-Pedelec');

    // Reifen: alle Upgrades sperren & abwählen
  groupSoftDisableUpgrades(SEL.tiresGroup, 'Nicht verfügbar bei S-Pedelec');


   

    // Travel sperren
    softDisableValuesByName(SEL.travelName, S_TRAVEL_DISABLED, 'Nicht verfügbar bei S-Pedelec');
    

    const currentTravel = getCheckedVal(SEL.travelName);
    if (currentTravel && S_TRAVEL_DISABLED.includes(currentTravel)) {
      if (!pickFirstPresent(SEL.travelName, S_TRAVEL_ALLOWED_PREFERRED)) {
        const checked = $(`${SEL.travelName}:checked`); if (checked) checked.checked = false;
      }
    }






// Styles aktualisieren
ensureVisibleSelection(SEL.cockpitName);
syncCheckedStyles(SEL.cockpitName);




  } else {
    /*
    // Pedelec: S-Pedelec-Batterie sperren und ggf. auf normale 800 Wh zurückstellen
softDisableValuesByName(SEL.battName, ['800 Wh (S-Pedelec)'], 'Nur bei S-Pedelec');
const currentBattRaw = getCheckedVal(SEL.battName);
if (isSPedBattLabel(currentBattRaw)) {
  // Fallback-Prio: 800 > 600 > 400 (sofern verfügbar)
  if (!pickFirstPresent(SEL.battName, ['800 Wh','600 Wh','400 Wh + 400 Wh'])) {
    // no-op; der Nutzer muss dann manuell wählen
  }
}

    // Pedelec
    softDisableValuesByName(SEL.motorName, ['Bosch CX.S'], 'Nur bei S-Pedelec');
    softDisableValuesByName(SEL.lightsName, ['S-Ped LIGHT by NIGHT'], 'Nur bei S-Pedelec');

    const allowed = VALID['Pedelec'][ctx.batt] || [];
    const toDisable = ALL_MOTORS.filter(m => !allowed.includes(m) && m !== 'Bosch CX.S');
    softDisableValuesByName(SEL.motorName, toDisable, 'Nicht erlaubt mit dieser Akku-Kombi');
    if (allowed.length && !allowed.includes(ctx.motor)) pickByName(SEL.motorName, allowed[0]);

    groupEnableAll(SEL.tiresGroup);
    */

    // 800er-Visibilität bei Pedelec
    hideByValue('800 Wh (S-Pedelec)', true);     // S-Ped-800 ausblenden
    hideByValue('800 Wh', false);                // Pedelec-800 einblenden

      // Pedelec: S-Pedelec-Akku sperren und 800 Wh wählen
    softDisableValuesByName(SEL.battName, ['800 Wh (S-Pedelec)'], 'Nur bei S-Pedelec');

    

    // Pedelec: S-Pedelec-Akku sperren
softDisableValuesByName(SEL.battName, ['800 Wh (S-Pedelec)'], 'Nur bei S-Pedelec');

(() => {
  const currentBattLabel = getCheckedVal(SEL.battName);
  const needsForce = !currentBattLabel || isSPedBattLabel(currentBattLabel);

  if (needsForce) {
    const b400 = document.querySelector(`${SEL.battName}[value="400 Wh + 400 Wh"]`);
    if (b400 && !b400.disabled && !b400.checked) {
      b400.click();
    } else if (!b400 || b400.disabled) {
      pickFirstPresent(SEL.battName, [
        '400 Wh + 400 Wh',
        '600 Wh',
        '800 Wh'
      ]);
    }
  }

  syncCheckedStyles(SEL.battName);
})();





    // Cockpit Sichtbarkeit (Pedelec)
hideByValue(COCKPIT_SPED,         true);   // S-Ped (Alu) ausblenden
hideByValue(COCKPIT_SPED_CARBON,  true);   // <<< NEU: S-Ped (Carbon) ausblenden
hideByValue(COCKPIT_COMFORT,      false);  // normales Comfort anzeigen
hideByValue(COCKPIT_ENDURO_CARBON, false);  // <<< wichtig

// Wenn zuvor S-Ped-Cockpit aktiv war, auf Fallback wechseln
if (getCheckedVal(SEL.cockpitName) === COCKPIT_SPED) {
  groupPickFirstPresent(SEL.cockpitGroup, [COCKPIT_COMFORT, ...COCKPIT_FALLBACKS]);
}


    // Pedelec – restliche Regeln
    softDisableValuesByName(SEL.motorName, ['Bosch CX.S'], 'Nur bei S-Pedelec');
    softDisableValuesByName(SEL.lightsName, ['S-Ped LIGHT by NIGHT'], 'Nur bei S-Pedelec');

    // WICHTIG: Motor-Kompatibilität anhand des JETZT gewählten Akkus rechnen
    const battNow = battCode(getCheckedVal(SEL.battName));           // <- neu
    const allowed = VALID['Pedelec'][battNow] || [];                 // <- neu
    const toDisable = ALL_MOTORS.filter(m => !allowed.includes(m) && m !== 'Bosch CX.S');
    softDisableValuesByName(SEL.motorName, toDisable, 'Nicht erlaubt mit dieser Akku-Kombi');
    if (allowed.length && !allowed.includes(getCheckedVal(SEL.motorName))) {
      pickByName(SEL.motorName, allowed[0]);
    }

    groupEnableAll(SEL.tiresGroup);


  }



    /* ============================
   Rahmengröße → Laufrad-Regel
   XL → kein FULL 29 Upgrade
   ============================ */
(function lockFull29ForXL(){
  const frameSize = getSelectedFrameSize();
  const FULL_29 = 'FULL 29 Upgrade';

  // FULL 29 Input finden (robust, auch bei Duplikaten)
  const inputs = findInputsByValue(FULL_29);
  if (!inputs.length) return;

  if (frameSize === 'XL') {
    inputs.forEach(inp => {
      visuallyDisableByInput(inp, 'Nicht verfügbar bei Rahmengröße XL');

      // optional: zusätzlich ausblenden
      const card = inp.closest('.gpo-ov-item') || inp.closest('label');
      if (card) card.style.display = 'none';
    });
  } else {
    // wieder freigeben, wenn nicht XL
    inputs.forEach(inp => {
      inp.disabled = false;
      const card = inp.closest('.gpo-ov-item') || inp.closest('label');
      if (card) {
        card.classList.remove('is-disabled');
        card.style.pointerEvents = '';
        card.style.display = '';
        card.removeAttribute('title');
      }
    });
  }
})();


/* ============================
   Mutual Exclusion:
   SPORT Gepäckträger ↔ FULL 29
   ============================ */
(function enforceSportVsFull29(){
  const SPORT = 'SPORT Gepäckträger Paket';
  const FULL29 = 'FULL 29 Upgrade';

  const sportInputs  = findInputsByValue(SPORT);
  const full29Inputs = findInputsByValue(FULL29);

  if (!sportInputs.length || !full29Inputs.length) return;

  const sportChecked  = sportInputs.some(i => i.checked);
  const full29Checked = full29Inputs.some(i => i.checked);

  // FULL 29 gewählt → SPORT sperren
  if (full29Checked) {
    sportInputs.forEach(inp => {
      visuallyDisableByInput(inp, 'Nicht kombinierbar mit FULL 29 Upgrade');
    });
  } 
  // SPORT gewählt → FULL 29 sperren
  else if (sportChecked) {
    full29Inputs.forEach(inp => {
      visuallyDisableByInput(inp, 'Nicht kombinierbar mit SPORT Gepäckträger Paket');
    });
  } 
  // keins gewählt → beide freigeben
  else {
    ((ctx.speed === 'S-Pedelec') ? full29Inputs : [...sportInputs, ...full29Inputs]).forEach(inp => {
      inp.disabled = false;
      const card = inp.closest('.gpo-ov-item') || inp.closest('label');
      if (card) {
        card.classList.remove('is-disabled');
        card.style.pointerEvents = '';
        card.removeAttribute('title');
      }
    });
  }
})();







  // ctx aktualisieren
  ctx.motor = getCheckedVal(SEL.motorName) || ctx.motor;
  ctx.batt  = battCode(getCheckedVal(SEL.battName)) || ctx.batt;
  ctx.grade = gradeCode(getCheckedVal(SEL.gradeName)) || ctx.grade;

  /* Harte Verbote */
  const hardBanned = new Set();
  HARD_BANS.forEach(b=>{
    if ((!b.grade || b.grade === ctx.grade) &&
        (!b.batt || (Array.isArray(b.batt) ? b.batt : [b.batt]).includes(ctx.batt))) {
      hardBanned.add(b.motor);
    }
  });
  if (hardBanned.size){
    softDisableValuesByName(SEL.motorName, [...hardBanned], 'Andere Kombination wählen');
    const allowedNow = (ctx.speed === 'S-Pedelec')
      ? VALID['S-Pedelec']['800']
      : (VALID['Pedelec'][ctx.batt] || []);
    const fallback = allowedNow.find(m => !hardBanned.has(m));
    if (fallback && !allowedNow.includes(ctx.motor)) pickByName(SEL.motorName, fallback);
  }

  /* Gruppen-Abhängigkeiten */
  applyGroupDeps(ctx);


 


  /* Travel-Checked-State synchronisieren */
syncCheckedStyles(SEL.travelName);
syncCheckedStyles(`${SEL.tiresGroup} input[type="radio"], ${SEL.tiresGroup} input[type="checkbox"]`);
ensureVisibleSelection(SEL.cockpitName);
syncCheckedStyles(SEL.cockpitName);

ensureVisibleSelection(SEL.displayName);
syncCheckedStyles(SEL.displayName);




/* --- AM 9.0 und 3.0 ausverkauft hard-lock --- */
(function lockSoldOutGrades(){
  const inputs = document.querySelectorAll(SEL.gradeName);
  let fallback = null;

  inputs.forEach(inp => {
    const isSoldOut = /9\.0/.test(inp.value) || /3\.0/.test(inp.value);
    const card = inp.closest(".gpo-ov-item") || inp.closest("label");

    if (!isSoldOut && !fallback && !inp.disabled) {
      fallback = inp;
    }

    if (!isSoldOut) return;

    // abwählen
    if (inp.checked) {
      inp.checked = false;
      inp.removeAttribute("checked");
      inp.setAttribute("previous-value", "false");
      inp.dispatchEvent(new Event("change", { bubbles:true }));
    }

    // sperren
    inp.disabled = true;
    if (card) {
      card.classList.add("is-disabled");
      card.style.pointerEvents = "none";
      card.title = "Ausverkauft";
      card.dataset.grade = /9\.0/.test(inp.value) ? "9.0" : "3.0";
    }
  });

  // falls 9.0 oder 3.0 aktiv → fallback
  const active = document.querySelector(`${SEL.gradeName}:checked`);
  if (active && (/9\.0/.test(active.value) || /3\.0/.test(active.value))) {
    if (fallback) fallback.click();
  }
})();



/* --- Tooltip-Override für AM 9.0 und 3.0 --- */
(function overrideSoldOutTooltips(){
  const soldOutInputs = document.querySelectorAll(
    `${SEL.gradeName}[value*="9.0"], ${SEL.gradeName}[value*="3.0"]`
  );

  soldOutInputs.forEach(inp => {
    const card = inp.closest('.gpo-ov-item') || inp.closest('label');
    if (!card) return;

    if (inp.disabled) {
      card.title = "Ausverkauft";
    }
  });
})();


/* --- BRUTALER Override: ALLE Tooltips für 9.0 und 3.0 überschreiben --- */
(function forceSoldOutTooltipOverride(){
  [`${SEL.gradeName}[value*="9.0"]`, `${SEL.gradeName}[value*="3.0"]`].forEach(selector => {
    const inp = document.querySelector(selector);
    if (!inp) return;

    const card = inp.closest('.gpo-ov-item') 
              || inp.closest('label') 
              || inp.parentElement;

    const targets = [];

    if (card) targets.push(card);

    if (card){
      targets.push(...card.querySelectorAll('[title]'));
      targets.push(...card.querySelectorAll('.gpo-ov-extend, .gpo-ov-title, .addOn, span, div'));
    }

    targets.push(inp);

    targets.forEach(el=>{
      if (!el) return;
      if (inp.disabled){
        el.setAttribute('title','Ausverkauft');
      }
    });
  });
})();




/* --- ULTRA LIGHT Carbon LRS 6.0 – immer AUSVERKAUFT --- */
(function lockUltraLightWheel(){
  const wheelsRoot = document.querySelector('.gpo-wheels');
  if (!wheelsRoot) return;

  const inputs = wheelsRoot.querySelectorAll(
    'input[type="radio"], input[type="checkbox"]'
  );

  let fallback = null;

  inputs.forEach(inp => {
    const isTarget = inp.value?.trim() === 'ULTRA LIGHT Carbon LRS 6.0';
    const card = inp.closest('.gpo-ov-item') || inp.closest('label');

    // Fallback = erstes anderes verfügbares Laufrad
    if (!isTarget && !fallback && !inp.disabled) {
      fallback = inp;
    }

    if (!isTarget) return;

    /* abwählen */
    if (inp.checked) {
      inp.checked = false;
      inp.removeAttribute('checked');
      inp.setAttribute('previous-value','false');
      inp.dispatchEvent(new Event('change',{bubbles:true}));
    }

    /* hart sperren */
    inp.disabled = true;

    if (card) {
      card.classList.add('is-disabled');
      card.style.pointerEvents = 'none';
      card.title = 'Ausverkauft';
    }
  });

  /* falls Ziel aktiv war → Fallback */
  const active = wheelsRoot.querySelector(
    'input[value="ULTRA LIGHT Carbon LRS 6.0"]:checked'
  );
  if (active && fallback) {
    fallback.click();
  }
})();


/* --- Tooltip-Hard-Override für ULTRA LIGHT Carbon LRS 6.0 --- */
(function forceUltraLightWheelTooltip(){
  const inp = document.querySelector(
    '.gpo-wheels input[value="ULTRA LIGHT Carbon LRS 6.0"]'
  );
  if (!inp) return;

  const card = inp.closest('.gpo-ov-item') || inp.closest('label');
  if (!card) return;

  const targets = [
    card,
    inp,
    ...card.querySelectorAll('[title], span, div')
  ];

  targets.forEach(el=>{
    if (!el) return;
    el.setAttribute('title','Ausverkauft');
  });
})();





}  // <--- ENDE applyDrive()




/* ============================
   Robust Bootstrapping
   ============================ */
function controlsReadyFully(){
  const speedWrap = document.querySelector(SEL.speedWrap);
  if (!speedWrap) return false;
  const radios = $$('input[type="radio"]', speedWrap).length;
  const items  = $$('.gpo-ov-item', speedWrap).length;
  if (radios < 2 || items < 2) return false;
  return !!document.querySelector(SEL.battWrap) && !!document.querySelector(SEL.motorWrap);
}

(function init(){
  let started = false;
  function startOnce(){
    if (started) return;
    if (!controlsReadyFully()) return;
    started = true;
    applyDrive();
    
    // einmal Akku Auswahl an Globo durchreichen
    setTimeout(() => {
      const batt = document.querySelector(`${SEL.battName}:checked`);
      if (!batt) return;
      batt.dispatchEvent(new Event('input',  { bubbles:true }));
      batt.dispatchEvent(new Event('change', { bubbles:true }));
    }, 400);

    syncCheckedStyles(SEL.travelName);
    document.addEventListener('change', e=>{
      const t = e.target;
      if (!t) return;
      if (t.matches(SEL.travelName)){
        syncCheckedStyles(SEL.travelName);
      }
      if (
  t.matches(SEL.speedName)  ||
  t.matches(SEL.battName)   ||
  t.matches(SEL.motorName)  ||
  t.matches(SEL.gradeName)  ||
  t.matches(SEL.travelName) ||
  t.matches(SEL.lightsName) ||
  t.matches(SEL.tiresName)  ||
  t.matches(SEL.displayName) ||
  t.matches('input[name="Rahmengröße"]')  
){
    applyDrive();
}
    }, { passive:true });
    const root = document.querySelector('.gpo-app') || document.body;
    const mo = new MutationObserver(()=>{ if (controlsReadyFully()) applyDrive(); });
    mo.observe(root, { childList:true, subtree:true });
    window.addEventListener('pageshow', ev => { if (ev.persisted) applyDrive(); });
  }
  const waiter = new MutationObserver(startOnce);
  waiter.observe(document.documentElement, { childList:true, subtree:true });
  startOnce();
  let tries = 0;
  const poll = setInterval(()=>{ startOnce(); if (++tries > 160 || started) clearInterval(poll); }, 50);
})();



/* Konfigurator Logik Ende */